
import React from 'react';

const VisionIcon = () => (
  <svg className="w-12 h-12 text-jskool-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
);
const MissionIcon = () => (
  <svg className="w-12 h-12 text-jskool-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 012-2h2a2 2 0 012 2v6m-6 0h6M9 19H5a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v10a2 2 0 01-2 2h-4m-6 0v-6m6 6v-6"></path></svg>
);
const ApproachIcon = () => (
  <svg className="w-12 h-12 text-jskool-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"></path></svg>
);

const AboutCard: React.FC<{ title: string; icon: React.ReactNode; children: React.ReactNode }> = ({ title, icon, children }) => {
    return (
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center flex flex-col items-center transform hover:scale-105 transition-transform duration-300">
            <div className="bg-jskool-cream rounded-full p-4 mb-4">
                {icon}
            </div>
            <h3 className="font-heading text-2xl font-extrabold text-jskool-dark mb-3">{title}</h3>
            <p className="text-jskool-dark/80">{children}</p>
        </div>
    )
}

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-heading font-extrabold text-jskool-dark">About JSkool</h2>
          <p className="mt-4 text-lg text-jskool-dark/70 max-w-3xl mx-auto">
            JSkool is an initiative of the Global Jain Foundation, created to make Jain Pathshala learning an engaging and enriching experience for everyone. We believe all Jains are part of one family, and our curriculum is inclusive of all traditions and sub-sects, welcoming all who wish to learn.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-10">
            <AboutCard title="Our Vision" icon={<VisionIcon/>}>
                To be a global center of excellence for Jain Pathshala education, nurturing a generation of compassionate and ethical leaders.
            </AboutCard>
            <AboutCard title="Our Mission" icon={<MissionIcon/>}>
                To empower Pathshala teachers and parents by creating a unified, accessible curriculum inclusive of all Jain traditions, making learning engaging for every age group.
            </AboutCard>
            <AboutCard title="Our Approach" icon={<ApproachIcon/>}>
                We provide ready-to-use content like comics, animations, and gamified modules, giving teachers powerful classroom tools and parents simple ways to teach at home.
            </AboutCard>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;